import React from 'react';
import { OrderProduct } from '../interfaces';
import DiscountValuePad from './DiscountValuePad';

interface AddDiscountValueProps {
    product: OrderProduct | any;
    onClose: () => void;
    onDiscountSubmit: (value: number, discountType: string, discountName?: string) => void;
}

const AddDiscountValue: React.FC<AddDiscountValueProps> = ({ onClose, product, onDiscountSubmit }) => {
    const base = product?.price != null ? Number(product.price) * (product.qty || 1) : undefined;
    return (
        <DiscountValuePad
            title="Add discount"
            subtitle={product?.name || product?.productName}
            initialValue={product?.discount}
            initialType={product?.discountType}
            initialName={product?.discountName}
            baseAmount={base}
            onClose={onClose}
            onSubmit={onDiscountSubmit}
        />
    );
};

export default AddDiscountValue;
